import { LibraryType } from '../../types/library';

// AI 단어장 생성 난이도
export enum AiDifficulty {
    EASY = 'EASY',
    NORMAL = 'NORMAL',
    HARD = 'HARD',
}

export const AiDifficultyLabels: Record<AiDifficulty, string> = {
    [AiDifficulty.EASY]: '쉬움 (일상 회화)',
    [AiDifficulty.NORMAL]: '보통 (중급)',
    [AiDifficulty.HARD]: '어려움 (고급)',
};

// 단어장 주제 정보
export interface WordbookTopicRequest {
    title: string;
    topic: string;
    wordCount: number;
    difficulty: AiDifficulty;
}

// AI 단일 단어장 생성 요청
export interface GenerateAiWordbookRequest {
    title: string;
    topic: string;
    headLang: string;
    meaningLang: string;
    wordCount: number;
    difficulty: AiDifficulty;
    registerToLibrary: boolean;
    libraryType: LibraryType;
    isVisible: boolean;
}

// AI 그룹 단어장 생성 요청
export interface GenerateAiGroupLibraryRequest {
    groupTitle: string;
    headLang: string;
    meaningLang: string;
    wordbooks: WordbookTopicRequest[];
    registerToLibrary: boolean;
    libraryType: LibraryType;
    isVisible: boolean;
}

// AI 단어장 생성 응답
export interface GenerateAiWordbookResponse {
    wordbookId: number;
    title: string;
    wordCount: number;
    libraryId?: number;
    message: string;
}

// AI 그룹 단어장 생성 응답
export interface GenerateAiGroupLibraryResponse {
    groupId: number;
    groupTitle: string;
    wordbooks: GeneratedWordbookInfo[];
    totalWordCount: number;
    libraryId?: number;
    message: string;
}

export interface GeneratedWordbookInfo {
    wordbookId: number;
    title: string;
    wordCount: number;
}
